import { ServiceProviderId } from '@business/entities/tm';
import { useBloc } from '@core/utils/bloc';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { PageHeader } from '@modules/common';
import { TableActions } from '@modules/common/TableActions';
import { openAddEditServiceProviderModal } from '@modules/settings/SettingsPage/Components/EstimateTab/AddEditServiceProviderModal';
import React, { memo, useCallback, useMemo } from 'react';
import { Container } from 'reactstrap';
import { ServiceProviderPageBloc } from './ServiceProviderTabBloc';
import { MDBDataTable } from 'mdbreact';
import { CBody } from '@modules/common/CBody';

export const ServiceProviderPage = memo(() => {
  const bloc = useBloc(ServiceProviderPageBloc);
  const Regions = useNonNilObservable(bloc.regions$);

  const onDelete = useCallback(
    (id: ServiceProviderId) => {
      bloc.deleteServiceProvider(id).subscribe();
    },
    [bloc],
  );

  const data = useMemo(
    () => ({
      columns: [
        {
          label: 'Name',
          field: 'name',
          sort: 'asc',
        },
        {
          label: 'Vendor',
          field: 'provider',
          sort: 'asc',
        },
        {
          label: 'Action',
          field: 'action',
          sort: 'asc',
        },
      ],
      rows: Regions.map(item => ({
        searchText: item.name,
        name: <p className="ml-2">{item.name}</p>,
        provider: <p className="ml-2">{item.user?.name}</p>,
        action: <TableActions onDelete={() => onDelete(item.id)} onEdit={() => openAddEditServiceProviderModal({ id: item.id })} />,
      })),
    }),
    [Regions, onDelete],
  );

  const buttons = useMemo(() => {
    return [
      {
        title: 'Add Vendor',
        onClick: () => openAddEditServiceProviderModal({}),
      },
    ];
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <PageHeader buttons={buttons}>Vendors</PageHeader>

        <CBody>
          <MDBDataTable responsive striped bordered data={data} paging={false} noBottomColumns displayEntries={false}></MDBDataTable>
        </CBody>
      </Container>
    </div>
  );
});
